/**
 * 鸣牌/荣和操作栏 —— 显示玩家可用的响应动作
 *
 * 触发时机：他家打出牌后，若自家能 吃/碰/杠/荣和 → 显示按钮
 * 玩家可选择「放弃」（pass）
 */

import { memo } from 'react';
import { Tile } from './Tile.js';

/** 可用的响应选项 */
export interface ResponseOption {
  /** 动作类型 */
  readonly kind: 'chi' | 'pon' | 'kan' | 'ron';
  /** 按钮文字 */
  readonly label: string;
  /** 副露要用的牌（吃/碰/杠时）*/
  readonly tiles?: readonly number[];
  /** 吃了哪几张（用于显示）*/
  readonly display?: readonly number[];
}

interface ResponseBarProps {
  /** 打出的牌（响应对象）*/
  readonly discardTile: number;
  /** 谁打的 */
  readonly discarderName: string;
  /** 可用选项 */
  readonly options: readonly ResponseOption[];
  /** 选择某动作 */
  readonly onSelect: (opt: ResponseOption) => void;
  /** 放弃 */
  readonly onPass: () => void;
}

export const ResponseBar = memo(function ResponseBar({
  discardTile,
  discarderName,
  options,
  onSelect,
  onPass,
}: ResponseBarProps) {
  return (
    <div className="response-bar">
      <div className="response-info">
        <span className="response-label">{discarderName} 打出</span>
        <Tile index={discardTile} scale="sm" />
      </div>

      <div className="response-actions">
        {options.map((opt, i) => (
          <button
            key={i}
            className={`btn response-btn response-${opt.kind}`}
            onClick={() => onSelect(opt)}
          >
            <span className="response-btn-label">{opt.label}</span>
            {opt.display && opt.display.length > 0 && (
              <span className="response-btn-tiles">
                {opt.display.map((t, j) => (
                  <Tile key={j} index={t} scale="xs" />
                ))}
              </span>
            )}
          </button>
        ))}

        <button className="btn btn-secondary response-pass" onClick={onPass}>
          放弃
        </button>
      </div>
    </div>
  );
});
